export default () => ({
  show: false,
  loading: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  unit: {
    unit_id: null,
    tower_id: null,
    available_for_rental: false
  },
  units: [],
  entity: 'unit',
  entities: 'units',
  dwellerUnits: [],
  dwellerTowers: [],
  prefixRouter: 'dweller.unit'
})



// WEBPACK FOOTER //
// ./src/app/tenant/unit/resources/data.js